module.exports = {
	"webSecurityWarning": "To help prevent malicious sites from getting access to your confidential data, confirm that you trust the following site:"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/json-loader!./resources/Shim_lib_resources_de-DE.json
 ** module id = 9
 ** module chunks = 0
 **/